// src/screens/seller/settings/Settings.js
import React from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import SettingsCards from "../../../subscreens/seller/settings/SellerSettingsCards";
import SellerMasterLayout from "../../../layouts/seller/SellerMasterLayout";
import "../../../assets/css/seller/screens/SellerSettings.css";

const SettingsManagement = () => {
  const { isDark } = useTheme();

  return (
    <SellerMasterLayout>
      <div className={`st-wrapper ${isDark ? "dark-mode" : ""}`}>
        <div className="st-shell">
          <div className="st-grid">
            <SettingsCards />
          </div>
        </div>
      </div>
    </SellerMasterLayout>
  );
};

export default SettingsManagement;